
import {nav1hr, newProduct, resolveValidTime} from "../productUtils.js";
import * as utc from "../../util/utc.js";
import {resolveTimeCursor} from "../../util/dates.js";
import {gaiaPath} from "../gaia.js";
import * as sources from "../sources.js";
import {ø} from "../../util/objects.js";
import {tr} from "../../ux/translations.js";
import {scalarProduct} from "../scalarProduct.js";
import {createUnitDescriptors} from "../../util/units.js";
import {createUVIPalette} from "../../palette/uvi.js";
import {clamp} from "../../util/math.js";

const CPCUVI_TIMELINE = [
    {
        type: "recurring_interval",
        start: "2021-05-03T13:00Z",
        frequency: {hours: 1},
    },
];

let palettes = {};

/**
 * @param {object} attr
 * @param {object} alignment
 * @returns {string}
 */
function cpcuviPath(attr, alignment) {
    const {time_cursor} = attr;
    const validTime = resolveValidTime(resolveTimeCursor(time_cursor), alignment);
    const isNow = time_cursor === "now";
    const dir = isNow ? "current" : utc.print(validTime, "{YYYY}/{MM}/{DD}");
    const stamp = isNow ? "current" : utc.print(validTime, "{hh}{mm}");
    const file = `${stamp}-cpcuvi.epak`;
    return gaiaPath("data/cpcuvi", dir, file);
}

const label = tr`UV Index`;
const category = [
    tr`low`,        //  0
    tr`low`,        //  1
    tr`low`,        //  2
    tr`moderate`,   //  3
    tr`moderate`,   //  4
    tr`moderate`,   //  5
    tr`high`,       //  6
    tr`high`,       //  7
    tr`very high`,  //  8
    tr`very high`,  //  9
    tr`very high`,  // 10
    tr`extreme`,    // 11
];

function asUVIndex(v) {
    return Math.round(v * 40);  // convert W/m^2 to UV Index
}

function format(v) {
    const x = asUVIndex(v);
    const c = category[clamp(x, 0, 11)];
    const formattedVal = `${x} (${c})`;
    const fullText = `${formattedVal} ${label}`;
    return {formattedVal, fullText, scalarHTML: formattedVal};
}

export function createCPCUVILayer(attr) {
    const base = ø(newProduct(), nav1hr(attr.time_cursor));
    return ø(base, {
        sourceHTML: sources.cpc,
        type: "uv_index",
        descriptionHTML: {
            name: tr`Ultraviolet Index and Erythemal Dose Rate`,
            qualifier: ` @ ${tr`Surface`}`,
        },
        timeline: CPCUVI_TIMELINE,
        paths: [cpcuviPath(attr, base.alignment())],
        builder: file => scalarProduct(file, /Ultra_Violet_Index_surface/, {hasMissing: false}),
        unitDescriptors: createUnitDescriptors({
            "UV Index": {convert: asUVIndex, precision: 0, html: label, format},
            "mW/m^2":   {convert: x => x * 1000, precision: 0},
        }),
        alpha: {single: 210, animated: 160},
        scale: palettes.uv ??= createUVIPalette(),
    });
}
